export const SKU_LIST_BZ10: string[] = [

    "BZ10-Bl-03",
    "BZ10-Bl-36",
    "BZ10-Bl-612",
    "BZ10-Bl-1218",
    "BZ10-Bl-1824",
    "BZ10-BuGuPi-03",
    "BZ10-BuGuPi-36",
    "BZ10-BuGuPi-612",
    "BZ10-BuGuPi-1218",
    "BZ10-Bu-03",
    "BZ10-Bu-36",
    "BZ10-Bu-612",
    "BZ10-Bu-1218",
    "BZ10-CaGr-03",
    "BZ10-CaGr-36",
    "BZ10-CaGr-612",
    "BZ10-CaGr-1218",
    "BZ10-CoBl-03",
    "BZ10-CoBl-36",
    "BZ10-CoBl-612",
    "BZ10-CoBl-1218",
    "BZ10-DuBl-03",
    "BZ10-DuBl-36",
    "BZ10-DuBl-612",
    "BZ10-DuBl-1218",
    "BZ10-DuRo-03",
    "BZ10-DuRo-36",
    "BZ10-DuRo-612",
    "BZ10-DuRo-1218",
    "BZ10-Fu-03",
    "BZ10-Fu-36",
    "BZ10-Fu-612",
    "BZ10-Fu-1218",
    "BZ10-HeBl-03",
    "BZ10-HeBl-36",
    "BZ10-HeBl-612",
    "BZ10-HeBl-1218",
    "BZ10-HeGyMe-03",
    "BZ10-HeGyMe-36",
    "BZ10-HeGyMe-612",
    "BZ10-HeGyMe-1218",
    "BZ10-KeGr-03",
    "BZ10-KeGr-36",
    "BZ10-KeGr-612",
    "BZ10-KeGr-1218",
    "BZ10-Mi-03",
    "BZ10-Mi-36",
    "BZ10-Mi-612",
    "BZ10-Mi-1218",
    "BZ10-NaNa-03",
    "BZ10-NaNa-36",
    "BZ10-NaNa-612",
    "BZ10-NaNa-1218",
    "BZ10-Or-03",
    "BZ10-Or-36",
    "BZ10-Or-612",
    "BZ10-Or-1218",
    "BZ10-OrNa-03",
    "BZ10-OrNa-36",
    "BZ10-OrNa-612",
    "BZ10-OrNa-1218",
    "BZ10-PoPi-03",
    "BZ10-PoPi-36",
    "BZ10-PoPi-612",
    "BZ10-PoPi-1218",
    "BZ10-Re-03",
    "BZ10-Re-36",
    "BZ10-Re-612",
    "BZ10-Re-1218",
    "BZ10-SaGr-03",
    "BZ10-SaGr-36",
    "BZ10-SaGr-612",
    "BZ10-SaGr-1218",
    "BZ10-SoYe-03",
    "BZ10-SoYe-36",
    "BZ10-SoYe-612",
    "BZ10-SoYe-1218",
    "BZ10-SuBl-03",
    "BZ10-SuBl-36",
    "BZ10-SuBl-612",
    "BZ10-SuBl-1218",
    "BZ10-To-03",
    "BZ10-To-36",
    "BZ10-To-612",
    "BZ10-To-1218",
    "BZ10-Wh-03",
    "BZ10-Wh-36",
    "BZ10-Wh-612",
    "BZ10-Wh-1218",
    "BZ10-Wh-1824"
]

